<div class="motif-dropdown">
  <div
    motifDropdown
    [ngClass]="'placement-bottom'"
    [placement]="Placement.BOTTOM_RIGHT"
    [scrollStrategy]="ScrollStrategy.Reposition"
    [autoClose]="true"
    [closeOnBackdropClick]="true"
    [attr.aria-expanded]="getAriaExpanded(open)"
    [open]="false">
    <button motifIconButton type="undefined" class="d-block" aria-label="Open context menu">
      <motif-icon
        [iconFunction]="isHeaderCell ? plusIcon : contextMenuButtonIcon"
        motifDropdownToggle
        aria-label="Dropdown menu button"
        id="motifDropdown"
        aria-controls="motifDropdownMenu"
        class="d-block"
        [attr.aria-expanded]="getAriaExpanded(open)"></motif-icon>
    </button>
    <div
      motifDropdownMenu
      id="motifDropdownMenu"
      aria-labelledby="motifDropdown">
      @for (item of menuItems; track item) {
        <button
          motifDropdownItem
          (click)="this.handleDeliverableTemplateMenuItemClick($event, item)">
          @if (isSvgIcon(item.icon)) {
            <img
              [src]="getSvgIconPath(item.icon)"
              alt=""
              class="context-menu-svg-icon"
              aria-hidden="true" />
          } @else {
            <motif-icon 
              [iconFunction]="iconMappingFunction(item.icon)"></motif-icon>
          }
          {{ item.text }}
        </button>
      }
      <span class="motif-dropdown-horizontal-divider" role="separator"></span>
    </div>
  </div>
</div>
